import {
  getDocument,
  type DocumentInitParameters,
  type PDFDocumentProxy,
  type TypedArray
} from './pdfjs';

export async function loadPdf(
  src: string | ArrayBuffer | URL | TypedArray | DocumentInitParameters
): Promise<PDFDocumentProxy | undefined> {
  if (src) {
    try {
      const task = getDocument(src);
      if (task) {
        return await task.promise;
      }
    } catch (e) {
      console.log(e instanceof Error ? e.message : e);
    }
  }

  return undefined;
}
